$(document).ready(function()
{

    // shoule work
    if ( $('#auto-search').length )
    {
        $('#auto-search').autocomplete({
            serviceUrl: '/wp/wp-admin/admin-post.php?action=search_suggest',
            //serviceUrl: '/test.json',
            //serviceUrl: '/test-empty.json',
            dataType: 'json',
            paramName: 'search',
            appendTo: $('.search-suggestions'),
            showNoSuggestionNotice: true,
            width: $('#auto-search').outerWidth(),
            minChars: 3,

            onSearchStart: function () 
            {
                $('.search-suggestions').css(
                {
                    'width': $('#auto-search').outerWidth(),
                });

                $('.search-suggestions').addClass('loading');

            },

            onSearchComplete: function () {
                $('.search-suggestions').removeClass('loading');
            },

            onSelect: function (suggestion) {
                window.location.href = suggestion.data
            },
        });

        $('#auto-search').on('focusout', function()
        {
            $('.search-suggestions').removeClass('loading');
        });
    }


});